<h4
  class="text-2xl leading-7 self-stretch text-[--color-text-primary] my-1 px-4"
  [ngClass]="{
    'lg:text-5xl text-3xl font-extrabold': lightMode(),
    'lg:text-3xl text-1xl': !lightMode(),
    'text-left font-bold': brand.isChmobile(),
    'text-center': !brand.isChmobile(),
    'group-[.custom-theme]/body:!text-[--basic-white]': isNavProduct(),
    'font-black': !isNavProduct(),
  }"
>
  {{ product().name }}
</h4>
